const Clipboard = () => {
  const url = location.href;
  const copyBtn = document.querySelector('.js-copy');
  copyBtn.addEventListener('click', () => {
    navigator.clipboard.writeText(url);

    const html = `<span class="willGone">URLコピー完了</span>`;
    copyBtn.insertAdjacentHTML('beforeend', html);
    const deleteHtml = document.querySelector('.willGone');

    setTimeout(() => {
      deleteHtml.classList.add('showhide');
      setTimeout(() => {
        deleteHtml.classList.remove('showhide');
        setTimeout(() => {
          copyBtn.removeChild(deleteHtml);
        }, 100);
      }, 1500);
    }, 300);
  });
};

export default Clipboard;
